// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1OByQ","left":"InfoRow_left__e8PpJ"};